import { render, staticRenderFns } from "./_notificationId.vue?vue&type=template&id=66789c48&scoped=true&"
import script from "./_notificationId.vue?vue&type=script&lang=js&"
export * from "./_notificationId.vue?vue&type=script&lang=js&"
import style0 from "./_notificationId.vue?vue&type=style&index=0&id=66789c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66789c48",
  null
  
)

export default component.exports